export default {
  getActiveLanguage: state => state.activeLanguage,
  getActiveStopCommand: (state) => state.speechRecognitionLanguages[state.activeLanguage].stopCommand,
  getLanguages: state => state.speechRecognitionLanguages
}
